import {
    PRODUCT_GRID_DATA,
    PRODUCT_GRID_ERROR,
    PRODUCT_GRID_LOADING,
    PRODUCT_GRID_PAGE_CHANGE,
    PRODUCT_GRID_STATE_CHANGE,
} from "../constants";
import { authExpire } from "../../auth/actions";
import { makePrivateApiCall } from "utilities/dist/api";

export const loadProductGridPage = (state, grid) => dispatch => {
    let { lastRow, sortModel, filterModel, dateRange, customerId } = state;

    dispatch({
        type: PRODUCT_GRID_LOADING,
    });

    const params = {
        endRow: grid.endRow,
        filterModel,
        sortModel,
        startRow: grid.startRow,
    };
    const dateFragments = dateRange.split(" - ");

    if (dateFragments.length > 1) {
        params.dateFrom = dateFragments[0].trim();
        params.dateTo = (dateFragments[1] || dateFragments[0]).trim();
    }

    if (customerId) {
        params.customerId = customerId;
    }

    return makePrivateApiCall({
        url: "/product",
        method: "get",
        params,
    })
        .then(res => {
            if (res.data) {
                const products = res.data.rows;
                lastRow = res.data.count;

                if (grid.successCallback) grid.successCallback(products, lastRow);
                dispatch({
                    type: PRODUCT_GRID_DATA,
                    payload: {
                        products,
                    },
                });
            }
        })
        .catch(err => {
            if (grid.failCallback) grid.failCallback(err);
            if (err.response && err.response.status === 401) {
                return dispatch(authExpire());
            }

            dispatch({
                type: PRODUCT_GRID_ERROR,
                payload: err.message,
            });
        });
};

export const changeProductGridPage = page => {
    return {
        type: PRODUCT_GRID_PAGE_CHANGE,
        payload: page,
    };
};

export const changeProductGridState = gridState => dispatch =>
    dispatch({
        type: PRODUCT_GRID_STATE_CHANGE,
        payload: gridState,
    });

export const fetchAllProducts = async state => {
    const { sortModel, filterModel, dateRange, customerId } = state;

    const params = {
        startRow: 0,
        endRow: -1,
        filterModel,
        sortModel,
    };

    const dateFragments = dateRange.split(" - ");
    if (dateFragments.length > 1) {
        params.dateFrom = dateFragments[0].trim();
        params.dateTo = (dateFragments[1] || dateFragments[0]).trim();
    }

    if (customerId) {
        params.customerId = customerId;
    }

    const res = await makePrivateApiCall({
        url: "/product",
        method: "get",
        params,
    });

    return res.data.rows;
};

export const resetProductPriceToListPrice = async (productId, customerId) => {
    return await makePrivateApiCall({
        url: `/product/price-change/reset`,
        method: "post",
        data: { product_id: productId, customer_id: customerId },
    });
};
